export default {
  cross: 'M24 6.998h-6.998V0H7.05v6.998H0v9.952h7.05V24h9.952v-7.05H24V6.998Z',
  x: 'M.703.703a2.4 2.4 0 0 1 3.394 0L12 8.606 19.903.703a2.4 2.4 0 0 1 3.394 3.394L15.394 12l7.903 7.903a2.4 2.4 0 0 1-3.394 3.394L12 15.394l-7.903 7.903a2.4 2.4 0 0 1-3.394-3.394L8.606 12 .703 4.097a2.4 2.4 0 0 1 0-3.394Z'
}